import StyledButton from "@/components/StyledButton/StyledButton";

type DialogProps = {
  title?: string;
  subtitle?: string;
  fullScreen?: boolean;
  center?: boolean;
  className?: string;
  children?: React.ReactNode;
  isActionButtonVisible?: boolean;
  actionButtonTitle?: string;
  isCancelButtonVisible?: boolean;
  cancelButtonTitle?: string;
  onClose?: () => void;
  onAction?: () => void; // Add this
};

const Dialog: React.FC<DialogProps> = ({
  title,
  subtitle,
  center,
  className,
  children,
  isActionButtonVisible = true,
  actionButtonTitle = "Save",
  isCancelButtonVisible = true,
  cancelButtonTitle = "Cancel",
  onClose,
  onAction, // Add this new prop
}) => {
  const fullScreenStyle = "z-[100] fixed inset-0 w-full h-full bg-blue-slate/20";
  const centerStyle = "justify-center items-center h-[517px] w-[492px] ml-[32%] mt-[12%]";
  
  const renderControlButtons = () => (
    <div className="justify-center flex flex-row w-full mt-[20px] gap-2">
      {isCancelButtonVisible && (
        <StyledButton
          text={cancelButtonTitle}
          className="min-w-[56px] px-[32px] text-blue bg-white rounded-sm"
          onClick={onClose} // Cancel calls onClose
        />
      )}
      {isActionButtonVisible && (
        <StyledButton
          text={actionButtonTitle}
          className="min-w-[56px] px-[32px] text-white rounded-sm"
          onClick={onAction} // Action button calls onAction
        />
      )}
    </div>
  );

  return (
    <div className={`${fullScreenStyle} ${className} flex p-2`}>
      <div className={`${center && centerStyle} flex-item flex flex-row bg-white rounded-md border-1 border-gray-650 shadow-gray-900 min-h-[30%] min-w-[40%] relative p-6`}>
        <div className="flex flex-col">
          <div className="text-black font-semibold text-lg">{title}</div>
          {subtitle && <div className="text-gray">{subtitle}</div>}
          {children}
          {renderControlButtons()}
        </div>
        <button className="absolute top-2 right-2" onClick={onClose} data-testid="close-button">
          <span className="text-2xl text-gray icon-close" />
        </button>
      </div>
    </div>
  );
};
export default Dialog;
